<template>
  <b-alert :variant="color" show class="mb-0 w-50 mt-2">
    <div class="alert-body">
      <feather-icon icon="InfoIcon" size="16" class="mx-50" />
      <span
        style="font-size: medium; text-align: justify; line-height: 175%"
        v-html="massage"
      ></span>
    </div>
  </b-alert>
</template>

<script>
import { BAlert } from "bootstrap-vue";
export default {
  props: {
    massage: {
      type: String,
    },
    color: {
      type: String,
      default: () => "warning",
    },
  },
  components: {
    BAlert,
  },
};
</script>
